"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapFlightStatusToItem = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const reservationStatusLabels = {
    created: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:StatusPending', defaultMessage: 'Pending' })),
    departed: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:StatusDeparted', defaultMessage: 'Departed' })),
    cancelled: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:StatusCancelled', defaultMessage: 'Cancelled' })),
    closed: 'unexpected closed',
};
const mapFlightStatusToItem = (cancelledCount) => (value) => {
    if (value === 'cancelled') {
        return {
            value,
            label: (react_1.default.createElement(react_1.default.Fragment, null,
                reservationStatusLabels.cancelled,
                " ",
                cancelledCount > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    "(",
                    cancelledCount,
                    ")")))),
            modificators: cancelledCount > 0 ? 'accent' : undefined,
        };
    }
    return {
        value,
        label: reservationStatusLabels[value],
    };
};
exports.mapFlightStatusToItem = mapFlightStatusToItem;
//# sourceMappingURL=utils.js.map